import {createGrid} from "../../helpers/grids/grids";
import {
	createCellRenderer,
	createDoubleClickHandler,
	createTruncatedTextCellRenderer
} from "../../helpers/grids/helpers";
import createElement from "../../helpers/createElement";
import {loading} from "../../helpers/loading";

function initClientAccountHome() {
	createGrid('.client-voe-orders-grid', {
			columnDefs: [
				{
					field: "public_id",
					headerName: 'Order Id',
					tooltipField: 'public_id',
					cellRenderer: createTruncatedTextCellRenderer(10, true),
				},
				{
					field: "full_name",
					headerName: 'Full Name',
					sortable: true,
				},
				{
					field: "company_name",
					headerName: 'Company Name',
					sortable: true,
				},
				{
					field: "status_label",
					headerName: 'Status',
				},
				{
					field: "timeInQueue",
					headerName: 'Total Time',
					sortable: true,
				},
				{
					field: "public_id",
					headerName: '',
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						const detailRoute = params.data.detailRoute;

						return createElement(`
							<div class="buttons">
                                <a
                                	class="btn btn-primary btn-sm" href="${detailRoute}"
                                >
                                    <i class="fa-solid fa-eye"></i>
                                    View
								</a>
                            </div>
						`);
					})
				},
			],
			onRowDoubleClicked: createDoubleClickHandler(data => {
				// noinspection JSUnresolvedVariable
				if (data.detailRoute) {
					loading();
					window.location.href = data.detailRoute
				}
			}),
			rowClass: 'cursor-pointer',
			paginationPageSize: 20,
			_rowName: 'Orders',
			_autoRefresh: true,
		},
		window['routes/client.grid']
	);
}

export {initClientAccountHome}
